import script from "./UserReply.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserReply.vue?vue&type=script&setup=true&lang=ts"

import "./UserReply.vue?vue&type=style&index=0&id=0f65b94e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f65b94e"]])

export default __exports__